import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ id, label, onChange, checked }) => {
    return (
        <>
            {/* Specifically using type="checkbox" to avoid customizing click handling to toggle */}
            <input id={id} type="checkbox" className="radio__input" checked={checked} onChange={onChange} />
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
            <label className="radio__label" htmlFor={id}>
                <h4>{label}</h4>
            </label>
        </>
    );
};

Radio.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
};

export default Radio;
